/**
 * Format a role name for display in the UI.
 * Converts camelCase/known role identifiers to human-readable labels.
 *
 * Examples:
 *   "tenantAdmin"  → "Tenant Admin"
 *   "systemAdmin"  → "System Admin"
 *   "pilot"        → "Pilot"
 *   "superAdmin"   → "Super Admin"
 */

const ROLE_DISPLAY_MAP: Record<string, string> = {
  tenantAdmin: 'Tenant Admin',
  systemAdmin: 'System Admin',
  superAdmin: 'Super Admin',
  admin: 'Admin',
  pilot: 'Pilot',
  driver: 'Driver',
  doctor: 'Doctor',
  supervisor: 'Supervisor',
  staff: 'Staff',
  user: 'User',
};

/**
 * Convert a single role identifier to a display-friendly string.
 */
export const formatRoleName = (role: string): string => {
  if (ROLE_DISPLAY_MAP[role]) return ROLE_DISPLAY_MAP[role];
  // Fallback: split camelCase → "tenantAdmin" → "Tenant Admin"
  return role
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, (c) => c.toUpperCase());
};

/**
 * Format an array of roles into a comma-separated display string.
 */
export const formatRoles = (roles: string[]): string => {
  return roles.map(formatRoleName).join(', ');
};
